import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout'
import store from '@/store'

Vue.use(Router);

const login = (resolve) => {
	import('@/view/system/login.vue').then((module) => {
		resolve(module);
	});
};
const homepage = (resolve) => {
	import('@/view/home/index.vue').then((module) => {
		resolve(module);
	});
};
const homeContentPage = (resolve) => {
	import('@/view/home/home.vue').then((module) => {
		resolve(module);
	});
};
const mycenter = (resolve) => {
	import('@/view/mycenter/index.vue').then((module) => {
		resolve(module);
	});
};

Router.prototype.urlMap = new Map();

const router = new Router({
	routes: [{
			path: '/',
			component: Layout,
			meta: {
				isLogin: false
			},
			children: [{
				path: '/',
				name: 'home',
				component: homepage,
				meta: {
					isLogin: false
				},
				children: [{
						path: '/home',
						meta: {
							parent: 'home',
							isLogin: false
						},
						component: homeContentPage
					},
					{
						path: '/goodsList',
						meta: {
							parent: 'home',
							isLogin: false
						},
						component: (resolve) => {
							import('@/view/product/goodsList.vue').then((module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/goodsDetail',
						meta: {
							parent: 'home',
							isLogin: false
						},
						component: (resolve) => {
							import('@/view/product/goodsDetail.vue').then((module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/submitOrder',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/submitOrder/index.vue').then((module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/cart',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/mycenter/cart.vue').then((module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/orderDetails',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/mycenter/orderDetails.vue').then((module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/home/newGather',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/mycenter/newGather.vue').then((
								module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/coupon',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/coupon/coupon.vue').then((
								module) => {
								resolve(module);
							});
						}
					},
					{
						path: '/mycenter',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: mycenter,
						children: [{
								path: '/myCoupon',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/myCoupon.vue').then((
										module) => {
										resolve(module);
									});
								}
							},
							{
								path: '/order-list',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/orderList.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/location',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/location.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/comparePrice',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/comparePrice.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/service',
								meta: {
									parent: 'mycenter',
									isLogin: false
								},
								component: (resolve) => {
									import('@/view/mycenter/service.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/newGather',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/newGather.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/certification',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/certification.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/myAccount',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/myAccount.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/changePasswd',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/changePasswd.vue').then((
										module) => {
										resolve(module);
									});
								}
							}, {
								path: '/accountInfo',
								meta: {
									parent: 'mycenter',
									isLogin: true
								},
								component: (resolve) => {
									import('@/view/mycenter/accountInfo.vue').then((
										module) => {
										resolve(module);
									});
								}
							}
						]
					},
					{
						path: '/panicBuying',
						meta: {
							parent: 'home',
							isLogin: true
						},
						component: (resolve) => {
							import('@/view/product/panicBuying.vue').then((
								module) => {
								resolve(module);
							});
						}
					},
				]
			}]
		},
		{
			path: '/login',
			component: login,
			meta: {
				isLogin: false
			},
		}, {
			path: '/license',
			meta: {
				isLogin: false
			},
			component: (resolve) => {
				import('@/layout/views/license.vue').then((
					module) => {
					resolve(module);
				});
			}
		}, {
			path: '/chooseGroup',
			component: (resolve) => {
				import('@/view/system/chooseGroup.vue').then((
					module) => {
					resolve(module);
				});
			},
			meta: {
				isLogin: true
			},
		}
	]
});

export default router;

// 路由跳转之前进行统一拦截
router.beforeEach((to, from, next) => {
	// 清空搜索条件
	if (to.path !== '/goodsList' && to.path !== '/goodsDetail' && to.path !== '/goodsList/goodsDetail' && store
		.state.vuex_searchKey) {
		store.commit('SET_SEARCHKEY', '');
	}

	if (to.path === '' || to.path === '/') {
		next('/home');
	} else {
		if (router.app.$options.store && router.app.$options.store.getters && router.app.$options.store.getters
			.hasLogin) {
			next();
		} else {
			// 判断是否需要登录
			if (to.path !== '/login' && to.meta.isLogin) {
				next('/login?redirect=' + from.fullPath);
			} else {
				next();
			}
		}
	}
})